import React from 'react';

    function HomePage() {
      return (
        <div className="home">
          <h1>Empowering Child Care Providers</h1>
          <div className="email-address">
              Contact at: <a href="mailto:info@etaswa.org">info@etaswa.org</a>
          </div>
        </div>
      );
    }

    export default HomePage;